export default __webpack_public_path__ + "static/brandlogo-f9958f8376e78b7e6c02e64329efd7b6.svg";